import { render, staticRenderFns } from "./driverDriverStatusLists.vue?vue&type=template&id=482c7230&scoped=true&"
import script from "./driverDriverStatusLists.vue?vue&type=script&lang=js&"
export * from "./driverDriverStatusLists.vue?vue&type=script&lang=js&"
import style0 from "./driverDriverStatusLists.vue?vue&type=style&index=0&id=482c7230&scoped=true&lang=css&"
import style1 from "./driverDriverStatusLists.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c7230",
  null
  
)

export default component.exports